<template>
  <div>
    <div id="main-container">
      <div id="algolia-content-container" class="data-list-container">
        <vs-table ref="table" class="pb-5" search pagination :max-items="itemsPerPage" :data="trustedPartners">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <vs-button color="primary" type="border" icon-after icon="add" @click="showAddNew = true">Add New Trusted Partner</vs-button>
            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ trustedPartners.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : trustedPartners.length }} of {{ trustedPartners.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <template slot="thead">
            <vs-th sort-key="company_id">ID</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="active">Active</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody :data="trustedPartner" :key="indextr" v-for="(trustedPartner, indextr) in data" @click="goToTrustedPartner(trustedPartner.id)">
            <vs-tr class="cursor-pointer">
              <vs-td>
                <p class="product-name font-medium truncate">{{ trustedPartner.id }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ trustedPartner.name }}</p>
              </vs-td>
              <vs-td>
                <vs-chip v-if="trustedPartner.active === 1" color="success">Yes</vs-chip>
                <vs-chip v-else color="warning">No</vs-chip>
              </vs-td>
            </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </div>

    <vs-prompt buttons-hidden title="Add Trusted Partner" :active="showAddNew" @close="close">
      <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
      <div class="vx-row mb-3" style="max-height: 550px; overflow-y: scroll;">
        <div class="vx-col w-full">
          <vs-input
            label="Trusted Partner Name"
            class="w-full mb-3"
            v-model="formData.name"
            :danger="!!errors.name"
            :danger-text="errors.name || null"
            val-icon-danger="error_outline"
          />
          <vs-input
            label="Web Url"
            class="w-full"
            v-model="formData.web_url"
            :danger="!!errors.web_url"
            :danger-text="errors.web_url || null"
            val-icon-danger="error_outline"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-4">
          <vs-button class="mx-1 w-full" @click="createTrustedPartner">Create</vs-button>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import api from '@/http/api';

export default {
  components: {},
  data() {
    return {
      itemsPerPage: 25,
      isMounted: false,
      showAddNew: false,
      loading: false,
      trustedPartners: [],
      formData: {
        name:'',
        web_url:''
      },
      errors: {}
    }
  },
  mounted() {
    this.isMounted = true;
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.trustedPartners = await api.getTrustedPartners();
    },
    async createTrustedPartner() {
      const errors = this.validateForm();
      if (errors) return;

      this.loading = true;
      const result = await api.createTrustedPartner(this.formData);
      this.loading = false;

      if(!result) return; //set some errs or something

      await this.fetchData();
      this.showAddNew = false;
      this.$vs.notify({
        title: 'Success',
        text: `Added ${this.formData.name} successfully!`,
        color: 'success',
        icon: 'check_circle_outline'
      });
      this.clearForm();
    },
    validateForm() {
      this.errors = {};
      const regexWebUrl = '^((https?|ftp|smtp):\\/\\/)?(www.)?[a-z0-9]+\\.[a-z]+(\\/[a-zA-Z0-9#]+\\/?)*$';

      if (!this.formData.name.length) this.errors.name = 'Name is required';
      if (!this.formData.web_url.match(regexWebUrl)) this.errors.web_url = "Must be a valid web url";

      return Object.keys(this.errors).length > 0;
    },
    clearForm() {
      this.formData = {
        name: '',
        web_url: ''
      }
    },
    close() {
      this.clearForm();
      this.showAddNew = false;
    },
    async goToTrustedPartner(trusted_partner_id) {
      // this.showCreateCompanyDialogFlag = false;
      // // just give the UI enough time to close the dialog
      // await new Promise(resolve => setTimeout(resolve, 300));
      this.$router.push(`/content/trusted-partners/${trusted_partner_id}`).catch(() => {});
    },
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  }
}

</script>
